/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as CRouteImport } from './routes/c'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CPrivaryPolicyRouteImport } from './routes/c/privary-policy'
import { Route as COrdersRouteImport } from './routes/c/orders'
import { Route as CCheckoutRouteImport } from './routes/c/checkout'
import { Route as CMenuLayoutRouteImport } from './routes/c/_menuLayout'
import { Route as CMenuLayoutIndexRouteImport } from './routes/c/_menuLayout/index'
import { Route as CPickupMapRouteImport } from './routes/c/pickup/map'
import { Route as COrderOrderIdRouteImport } from './routes/c/order.$orderId'
import { Route as COrderTrackingOrderIdRouteImport } from './routes/c/order-tracking.$orderId'
import { Route as CMenuLayoutCartRouteImport } from './routes/c/_menuLayout/cart'
import { Route as CMenuLayoutItemItemIdRouteImport } from './routes/c/_menuLayout/item.$itemId'

const CRoute = CRouteImport.update({
  id: '/c',
  path: '/c',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CPrivaryPolicyRoute = CPrivaryPolicyRouteImport.update({
  id: '/privary-policy',
  path: '/privary-policy',
  getParentRoute: () => CRoute,
} as any)
const COrdersRoute = COrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => CRoute,
} as any)
const CCheckoutRoute = CCheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => CRoute,
} as any)
const CMenuLayoutRoute = CMenuLayoutRouteImport.update({
  id: '/_menuLayout',
  getParentRoute: () => CRoute,
} as any)
const CMenuLayoutIndexRoute = CMenuLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CMenuLayoutRoute,
} as any)
const CPickupMapRoute = CPickupMapRouteImport.update({
  id: '/pickup/map',
  path: '/pickup/map',
  getParentRoute: () => CRoute,
} as any)
const COrderOrderIdRoute = COrderOrderIdRouteImport.update({
  id: '/order/$orderId',
  path: '/order/$orderId',
  getParentRoute: () => CRoute,
} as any)
const COrderTrackingOrderIdRoute = COrderTrackingOrderIdRouteImport.update({
  id: '/order-tracking/$orderId',
  path: '/order-tracking/$orderId',
  getParentRoute: () => CRoute,
} as any)
const CMenuLayoutCartRoute = CMenuLayoutCartRouteImport.update({
  id: '/cart',
  path: '/cart',
  getParentRoute: () => CMenuLayoutRoute,
} as any)
const CMenuLayoutItemItemIdRoute = CMenuLayoutItemItemIdRouteImport.update({
  id: '/item/$itemId',
  path: '/item/$itemId',
  getParentRoute: () => CMenuLayoutRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/c': typeof CMenuLayoutRouteWithChildren
  '/c/checkout': typeof CCheckoutRoute
  '/c/orders': typeof COrdersRoute
  '/c/privary-policy': typeof CPrivaryPolicyRoute
  '/c/cart': typeof CMenuLayoutCartRoute
  '/c/order-tracking/$orderId': typeof COrderTrackingOrderIdRoute
  '/c/order/$orderId': typeof COrderOrderIdRoute
  '/c/pickup/map': typeof CPickupMapRoute
  '/c/': typeof CMenuLayoutIndexRoute
  '/c/item/$itemId': typeof CMenuLayoutItemItemIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/c': typeof CMenuLayoutIndexRoute
  '/c/checkout': typeof CCheckoutRoute
  '/c/orders': typeof COrdersRoute
  '/c/privary-policy': typeof CPrivaryPolicyRoute
  '/c/cart': typeof CMenuLayoutCartRoute
  '/c/order-tracking/$orderId': typeof COrderTrackingOrderIdRoute
  '/c/order/$orderId': typeof COrderOrderIdRoute
  '/c/pickup/map': typeof CPickupMapRoute
  '/c/item/$itemId': typeof CMenuLayoutItemItemIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/c': typeof CRouteWithChildren
  '/c/_menuLayout': typeof CMenuLayoutRouteWithChildren
  '/c/checkout': typeof CCheckoutRoute
  '/c/orders': typeof COrdersRoute
  '/c/privary-policy': typeof CPrivaryPolicyRoute
  '/c/_menuLayout/cart': typeof CMenuLayoutCartRoute
  '/c/order-tracking/$orderId': typeof COrderTrackingOrderIdRoute
  '/c/order/$orderId': typeof COrderOrderIdRoute
  '/c/pickup/map': typeof CPickupMapRoute
  '/c/_menuLayout/': typeof CMenuLayoutIndexRoute
  '/c/_menuLayout/item/$itemId': typeof CMenuLayoutItemItemIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/c'
    | '/c/checkout'
    | '/c/orders'
    | '/c/privary-policy'
    | '/c/cart'
    | '/c/order-tracking/$orderId'
    | '/c/order/$orderId'
    | '/c/pickup/map'
    | '/c/'
    | '/c/item/$itemId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/c'
    | '/c/checkout'
    | '/c/orders'
    | '/c/privary-policy'
    | '/c/cart'
    | '/c/order-tracking/$orderId'
    | '/c/order/$orderId'
    | '/c/pickup/map'
    | '/c/item/$itemId'
  id:
    | '__root__'
    | '/'
    | '/c'
    | '/c/_menuLayout'
    | '/c/checkout'
    | '/c/orders'
    | '/c/privary-policy'
    | '/c/_menuLayout/cart'
    | '/c/order-tracking/$orderId'
    | '/c/order/$orderId'
    | '/c/pickup/map'
    | '/c/_menuLayout/'
    | '/c/_menuLayout/item/$itemId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CRoute: typeof CRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/c': {
      id: '/c'
      path: '/c'
      fullPath: '/c'
      preLoaderRoute: typeof CRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/c/privary-policy': {
      id: '/c/privary-policy'
      path: '/privary-policy'
      fullPath: '/c/privary-policy'
      preLoaderRoute: typeof CPrivaryPolicyRouteImport
      parentRoute: typeof CRoute
    }
    '/c/orders': {
      id: '/c/orders'
      path: '/orders'
      fullPath: '/c/orders'
      preLoaderRoute: typeof COrdersRouteImport
      parentRoute: typeof CRoute
    }
    '/c/checkout': {
      id: '/c/checkout'
      path: '/checkout'
      fullPath: '/c/checkout'
      preLoaderRoute: typeof CCheckoutRouteImport
      parentRoute: typeof CRoute
    }
    '/c/_menuLayout': {
      id: '/c/_menuLayout'
      path: ''
      fullPath: '/c'
      preLoaderRoute: typeof CMenuLayoutRouteImport
      parentRoute: typeof CRoute
    }
    '/c/_menuLayout/': {
      id: '/c/_menuLayout/'
      path: '/'
      fullPath: '/c/'
      preLoaderRoute: typeof CMenuLayoutIndexRouteImport
      parentRoute: typeof CMenuLayoutRoute
    }
    '/c/pickup/map': {
      id: '/c/pickup/map'
      path: '/pickup/map'
      fullPath: '/c/pickup/map'
      preLoaderRoute: typeof CPickupMapRouteImport
      parentRoute: typeof CRoute
    }
    '/c/order/$orderId': {
      id: '/c/order/$orderId'
      path: '/order/$orderId'
      fullPath: '/c/order/$orderId'
      preLoaderRoute: typeof COrderOrderIdRouteImport
      parentRoute: typeof CRoute
    }
    '/c/order-tracking/$orderId': {
      id: '/c/order-tracking/$orderId'
      path: '/order-tracking/$orderId'
      fullPath: '/c/order-tracking/$orderId'
      preLoaderRoute: typeof COrderTrackingOrderIdRouteImport
      parentRoute: typeof CRoute
    }
    '/c/_menuLayout/cart': {
      id: '/c/_menuLayout/cart'
      path: '/cart'
      fullPath: '/c/cart'
      preLoaderRoute: typeof CMenuLayoutCartRouteImport
      parentRoute: typeof CMenuLayoutRoute
    }
    '/c/_menuLayout/item/$itemId': {
      id: '/c/_menuLayout/item/$itemId'
      path: '/item/$itemId'
      fullPath: '/c/item/$itemId'
      preLoaderRoute: typeof CMenuLayoutItemItemIdRouteImport
      parentRoute: typeof CMenuLayoutRoute
    }
  }
}

interface CMenuLayoutRouteChildren {
  CMenuLayoutCartRoute: typeof CMenuLayoutCartRoute
  CMenuLayoutIndexRoute: typeof CMenuLayoutIndexRoute
  CMenuLayoutItemItemIdRoute: typeof CMenuLayoutItemItemIdRoute
}

const CMenuLayoutRouteChildren: CMenuLayoutRouteChildren = {
  CMenuLayoutCartRoute: CMenuLayoutCartRoute,
  CMenuLayoutIndexRoute: CMenuLayoutIndexRoute,
  CMenuLayoutItemItemIdRoute: CMenuLayoutItemItemIdRoute,
}

const CMenuLayoutRouteWithChildren = CMenuLayoutRoute._addFileChildren(
  CMenuLayoutRouteChildren,
)

interface CRouteChildren {
  CMenuLayoutRoute: typeof CMenuLayoutRouteWithChildren
  CCheckoutRoute: typeof CCheckoutRoute
  COrdersRoute: typeof COrdersRoute
  CPrivaryPolicyRoute: typeof CPrivaryPolicyRoute
  COrderTrackingOrderIdRoute: typeof COrderTrackingOrderIdRoute
  COrderOrderIdRoute: typeof COrderOrderIdRoute
  CPickupMapRoute: typeof CPickupMapRoute
}

const CRouteChildren: CRouteChildren = {
  CMenuLayoutRoute: CMenuLayoutRouteWithChildren,
  CCheckoutRoute: CCheckoutRoute,
  COrdersRoute: COrdersRoute,
  CPrivaryPolicyRoute: CPrivaryPolicyRoute,
  COrderTrackingOrderIdRoute: COrderTrackingOrderIdRoute,
  COrderOrderIdRoute: COrderOrderIdRoute,
  CPickupMapRoute: CPickupMapRoute,
}

const CRouteWithChildren = CRoute._addFileChildren(CRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CRoute: CRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
